<template>
  <div class="downloadFiles flex flex-wrap">
    <div class="downloadBtn flex justify-start items-center text-xs flex-wrap">
      <a :href="downloadFiles.lifePenFile[0].url" class="mp3Btn btn cursor-pointer h-10 rounded-full text-xs flex items-center pl-1 pr-3 mb-3 sm:mb-0 no-underline"
        v-if="downloadFiles.lifePenFile && downloadFiles.lifePenFile.length > 0">
        <div class="h-8 w-8 mr-1 relative">
          <img class="w-full h-full object-cotain btn-img absolute" src="~@/assets/images/readingPen/livepen-small.png"
          alt="LiveABC點讀音檔下載">
        </div>
        <div class="btn-content leading-tight">
          <p class="m-0 whitespace-no-wrap tracking-tight" v-if="category_id === 141 || category_id === 167">字典卡</p>
          <p class="m-0 whitespace-no-wrap tracking-tight"  v-if="category_id !== 141 && category_id !== 167">LiveABC點讀筆</p>
          <p class="m-0 whitespace-no-wrap">ECM音檔下載</p>
        </div>
      </a>
      <a :href="downloadFiles.myVoiceFile[0].url" class="mp3Btn btn cursor-pointer h-10 rounded-full text-xs flex items-center pl-1 pr-3 mb-3 sm:mb-0 no-underline"
        v-if="downloadFiles.myVoiceFile && downloadFiles.myVoiceFile.length > 0">
        <div class="h-8 w-8 mr-1 relative">
          <img class="w-full h-full object-cotain btn-img absolute" src="~@/assets/images/bluetooth_pen/bluetooth_pen.png"
            alt="MyVoice點讀音檔下載">
        </div>
        <div class="btn-content leading-tight">
          <p class="m-0 whitespace-no-wrap tracking-tight" v-if="category_id === 141 || category_id === 167">字典卡</p>
          <p class="m-0 whitespace-no-wrap tracking-tight"  v-if="category_id !== 141 && category_id !== 167">LiveABC點讀筆</p>
          <p class="m-0 whitespace-no-wrap">BNL音檔下載</p>
        </div>
      </a>
      <a :href="downloadFiles.Mp3File[0].url" class="mp3Btn mb-3 sm:mb-0 tracking-tight btn cursor-pointer h-10 rounded-full text-xs flex items-center justify-center whitespace-no-wrap no-underline"
        v-if="downloadFiles.Mp3File && downloadFiles.Mp3File.length > 0">MP3音檔下載</a>

      <a :href="downloadFiles.JLPTFile[0].url" class="mp3Btn mb-3 sm:mb-0 tracking-tight btn cursor-pointer h-10 rounded-full text-xs flex items-center justify-center whitespace-no-wrap no-underline"
        v-if="downloadFiles.JLPTFile && downloadFiles.JLPTFile.length > 0">JLPT模擬試題下載</a>

      <a :href="downloadFiles.uploadFile[0].url" class="mb-3 sm:mb-0 mp3Btn tracking-tight btn cursor-pointer h-10 rounded-full text-xs flex items-center justify-center whitespace-no-wrap no-underline"
        v-if="downloadFiles.uploadFile && downloadFiles.uploadFile.length > 0">書籍內容更新</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadFileBtns',

  props: {
    downloadFiles: {
      type: Object
    },
    dataId: {
      type: Number
    },
    category_id: {
      type: Number
    }
  },

  data () {
    return {
      url: null,
      isLoaded: false
    }
  },
  computed: {
  },
  watch: {

  },
  mounted () {

  },

  methods: {
    downloadFile (type) {
      let self = this
      if (type === 'LifePenFile') {
        for (let item of self.downloadFiles.lifePenFile) {
          window.open(item.url, '_blank')
        }
      } else if (type === 'myVoice') {
        for (let item of self.downloadFiles.myVoiceFile) {
          window.open(item.url, '_blank')
        }
      } else if (type === 'MP3') {
        for (let item of self.downloadFiles.Mp3File) {
          window.open(item.url, '_blank')
        }
      } else if (type === 'CONTENT_UPDATE') {
        for (let item of self.downloadFiles.uploadFile) {
          window.open(item.url, '_blank')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .downloadFiles {
    .downloadBtn {
      .btn {
        background-color: white;
        border: 1px solid black;
        color: #434343;
        font-size: 14px;
        font-weight: 400;
        margin: 0 .4rem;
        .btn-img {
          top: 0;
          right: 0;
          background-color: #FDEDED;
          clip-path: circle(50% at 50% 50%);
          -webkit-clip-path: circle(50% at 50% 50%);
          overflow: hidden;
        }
        &:hover {
          background-color: #e60012;
          color: white;
          border: 1px solid #e60012;
          .btn-img {
            background-color: white;
          }
        }
      }
      .mp3Btn {
        width: 144px;
      }
    }
  }
</style>
